import React from "react";

const DispatchManifestIcon = (props:any) => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.8" clipPath="url(#clip0_2511_12419)">
          <path
            d="M14.2204 17.1017C15.1939 17.1017 15.9831 16.3125 15.9831 15.339C15.9831 14.3655 15.1939 13.5763 14.2204 13.5763C13.2468 13.5763 12.4576 14.3655 12.4576 15.339C12.4576 16.3125 13.2468 17.1017 14.2204 17.1017Z"
            stroke={props?.color ?? "black"}
            strokeWidth="1.32203"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.40675 17.1017C6.38027 17.1017 7.16947 16.3125 7.16947 15.339C7.16947 14.3655 6.38027 13.5763 5.40675 13.5763C4.43324 13.5763 3.64404 14.3655 3.64404 15.339C3.64404 16.3125 4.43324 17.1017 5.40675 17.1017Z"
            stroke={props?.color ?? "black"}
            strokeWidth="1.32203"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.64407 15.3143C2.67722 15.2667 2.07525 15.123 1.64515 14.6938C1.21505 14.2646 1.07227 13.6618 1.02468 12.6949M7.16949 15.339H12.4576M15.9831 15.3143C16.9499 15.2667 17.5519 15.123 17.982 14.6938C18.6271 14.0478 18.6271 13.0096 18.6271 10.9322V9.16949H14.4847C13.8281 9.16949 13.5003 9.16949 13.235 9.08312C12.9704 8.99716 12.73 8.84981 12.5333 8.65312C12.3366 8.45644 12.1893 8.216 12.1033 7.95146C12.0169 7.68617 12.0169 7.3583 12.0169 6.70169C12.0169 5.71722 12.0169 5.22542 11.8874 4.82705C11.7584 4.43024 11.5374 4.06958 11.2424 3.77455C10.9474 3.47952 10.5867 3.2585 10.1899 3.12956C9.79153 3 9.29973 3 8.31525 3H1M1 6.52542H6.28814M1 9.16949H4.52542"
            stroke={props?.color ?? "black"}
            strokeWidth="1.32203"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.017 4.76273H13.6219C14.9052 4.76273 15.5459 4.76273 16.0677 5.07473C16.5903 5.38584 16.8944 5.95079 17.5025 7.08069L18.6271 9.16951"
            stroke={props?.color ?? "black"}
            strokeWidth="1.32203"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2511_12419">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default DispatchManifestIcon;
